<template>
  <section class="navigation-search">
    <div class="navigation-search__bar">
      <InputSearchQuery id="search" placeholder="Que cherchez-vous?" />
    </div>

    <div class="navigation-search__filters">
      <RouterLink
        :to="getEventTypeQuery('all')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': !$route.query.eventType }"
        replace
        exact
      >
        Toutes les types d'événements
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('webinar')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'webinar' }"
        replace
        exact
      >
        <SvgIcon id="content-web" />
        Webinaires
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('workshop')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'workshop' }"
        replace
        exact
      >
        <SvgIcon id="content-list" />
        Ateliers
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('forum')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'forum' }"
        replace
        exact
      >
        <SvgIcon id="content-forum" />
        Forum
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('award')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'award' }"
        replace
        exact
      >
        <SvgIcon id="content-trophy" />
        Remises de prix
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('seminar')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'seminar' }"
        replace
        exact
      >
        <SvgIcon id="content-edifice" />
        Séminaires
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('study')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'study' }"
        replace
        exact
      >
        <SvgIcon id="icon-book" />
        Journées d’études
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('assembly')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'assembly' }"
        replace
        exact
      >
        <SvgIcon id="bullet-people" />
        Assemblées générales
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('launch')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'launch' }"
        replace
        exact
      >
        <SvgIcon id="content-zoom-out" />
        Lancements
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('consultation')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'consultation' }"
        replace
        exact
      >
        <SvgIcon id="content-business" />
        Consultations
      </RouterLink>
    </div>

    <KeywordPickerQuery :dataset="allPublications" />
  </section>
</template>

<script>
export default {
  name: 'EventsIndexSearch',
  computed: {
    allPublications() {
      return this.$wp.eventPublications || []
    }
  },
  methods: {
    getEventTypeQuery(type) {
      const { page, eventType: currentType, ...queryRest } = this.$route.query
      const query = type === 'all' || currentType === type ? queryRest : { ...queryRest, eventType: type }
      return { query }
    }
  }
}
</script>
